import http from '@/biz/http.mjs'
import RuleType from './RuleType.jsx'

const ruleTypes = RuleType.map(([type]) => type)

export default {
    readList: args => http.get('/dmbds/rules', {ruleTypes, ...args}),
}
